import LsdApiModel from './global/LsdApiModel';

export default class AccountingDocumentHistoryModel extends LsdApiModel {
	static get path(): string {
		return '/accounting_document_histories/{?id}';
	}
}
